import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_ClientWaiver = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ROC_ClientWaiver' className='file-pdf-document'>
            <div className='file-template'>



                <p className='w-750'> <center> Waiver For Client </center> </p>
                <p className='w-750'>
                    I,

                    <input type='text' id='txtWaiverAcknowledge' name='txtWaiverAcknowledge' className='add-only' />
                    understand that by signing this release, I waive any and all claims against Restore Outreach Center, LLC and/or its staff for any liability including but not limited to personal/bodily injury (including death) and consumer property loss or damage during involvement in any class or activity sponsored by Restore Outreach Center, LLC. Consumer participation is voluntary, so the undersigned acknowledges the risks of potential injury associated with the physical aspects of activity participation.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client Signature</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Staff Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}